import { render, staticRenderFns } from "./B2CLoadingSpinner.vue?vue&type=template&id=2175249e&scoped=true"
import script from "./B2CLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./B2CLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./B2CLoadingSpinner.vue?vue&type=style&index=0&id=2175249e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175249e",
  null
  
)

export default component.exports